export default {
  autocompleteVats: [],
  vats: [],
  emptyVat: {},
  params: {
    entity: [],
    collection: []
  }
}